import React from 'react'
import Redirect from '../../../shared/components/atoms/redirect/redirect';
import './shared-social.scss';

const SharedSocial = props => {
    const { link, redes } = props;

    const SocialIcon = (social) => {
        
        switch (social) {
            case 'Facebook':
                return (
                    <Redirect url={ `https://www.facebook.com/sharer/sharer.php?u=${ link }` }>
                        <i className="fab fa-facebook-f"></i>
                    </Redirect>
                )
            case 'Twitter':
                return (
                    <Redirect url={ `https://twitter.com/intent/tweet?url=${link}` }>
                        <i className="fab fa-twitter"></i>
                    </Redirect>
                )
            case 'Whatsapp':
                return (
                    <Redirect url={ `https://api.whatsapp.com/send?text=${link}` }>
                        <i className="fab fa-whatsapp"></i>
                    </Redirect>
                )
            case 'Linkedin':
                return (
                    <Redirect url={ `http://www.linkedin.com/shareArticle?mini=true&url=${link}` }>
                        <i className="fab fa-linkedin-in"></i>
                    </Redirect>
                )
            case 'Email':
                return (
                    <a className="icon-mail" href={ `mailto:?body=${link}` }>
                        <i className="far fa-envelope"></i>
                    </a>
                )
            default:
                return <span>N</span>
        }
    }

    

    return (
        <div className="a-shared-social">
            {
                redes && redes.length > 0 &&
                <>
                    <span className="a-shared-social-title">Compartir</span>
                    <div className="a-shared-social-list-icon">
                        {
                            redes.map( (r,i)=>(
                                <div className="a-shared-social-icon" key={ i }>
                                    { SocialIcon( r ) }
                                </div>
                            ))
                        }
                    </div>
                </>
            }
        </div>
    )
}

export default SharedSocial
